import React from "react";
import store from './Stores/SurveyStore';
import surveySectionStore from './Stores/SurveySectionStore'
import {observer} from "mobx-react"
import SideNav, {Toggle, Nav, NavItem, NavIcon, NavText} from '@trendmicro/react-sidenav';

// Be sure to include styles at some point, probably during your bootstraping
import '@trendmicro/react-sidenav/dist/react-sidenav.css';

const SCROLL_OFFSET = 150;

const toggleNav = () => {
    store.showSideNav = !store.showSideNav;
}

const onItemSelected = (id) => {
    const ref = surveySectionStore.getSectionRef(id);
    if (ref?.current) {
        window.scrollTo({
            top: ref.current.offsetTop - SCROLL_OFFSET,
            behavior: "smooth",
        });
    }
}

/**
 * This panel shows a list of survey sections on the right side 
 * based on the sections in the center of the page.
 * @type {React.FC}
 */
const SubsectionPanel = observer(() => {
    if(!surveySectionStore.shouldShowSectionNavPanel) return null;
    
    const sectionIds = surveySectionStore.registeredSectionIds;
    if (!sectionIds || sectionIds.length <= 1) return null;

    return (
        <SideNav
            expanded={store.showSideNav}
            onToggle={toggleNav}
            className="side-nav-collapsible"
            id="slide"
            onSelect={onItemSelected}
        >
            <Toggle/>
            <Nav defaultSelected="home">
                {sectionIds.map((item) => (
                    <NavItem
                        key={item}
                        eventKey={item}
                    >
                        <NavIcon>
                        </NavIcon>
                        <NavText>
                            {item}
                        </NavText>
                    </NavItem>
                ))}
            </Nav>
        </SideNav>
    );
});

export default SubsectionPanel;
